interface CheckpointProps {
  fill?: string;
  width?: number;
  height?: number;
}

export const Checkpoint = ({
  fill = '#EF9021',
  width = 24,
  height = 24,
}: CheckpointProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.2" cx="12" cy="12" r="12" fill={fill} />
    <circle cx="12" cy="12" r="6" fill={fill} />
  </svg>
);
